module.exports = __webpack_public_path__ + "img/examples-en-5.d24e59c0.jpg";